import React, { useState, useEffect } from 'react';
import { X } from 'lucide-react';

const SignupNotification = () => {
  const [notification, setNotification] = useState(null);

  // Random names pool
  const firstNames = [
    'James', 'Michael', 'Robert', 'John', 'David', 'William', 'Richard', 'Thomas',
    'Sarah', 'Jennifer', 'Linda', 'Patricia', 'Elizabeth', 'Mary', 'Susan', 'Jessica',
    'Daniel', 'Matthew', 'Anthony', 'Mark', 'Donald', 'Steven', 'Andrew', 'Kenneth',
    'Emily', 'Ashley', 'Melissa', 'Michelle', 'Laura', 'Amy', 'Kimberly', 'Angela'
  ];

  const lastNames = [
    'Smith', 'Johnson', 'Williams', 'Brown', 'Jones', 'Garcia', 'Miller', 'Davis',
    'Rodriguez', 'Martinez', 'Hernandez', 'Lopez', 'Gonzalez', 'Wilson', 'Anderson', 'Thomas',
    'Taylor', 'Moore', 'Jackson', 'Martin', 'Lee', 'Thompson', 'White', 'Harris',
    'Clark', 'Lewis', 'Robinson', 'Walker', 'Young', 'Allen', 'King', 'Wright'
  ];

  // Membership tiers with billing cycles
  const membershipTiers = [
    { name: 'CORE', cycle: 'Monthly', color: 'text-neutral-400' },
    { name: 'CORE', cycle: 'Yearly', color: 'text-neutral-400' },
    { name: 'PRO', cycle: 'Monthly', color: 'text-[#CBB26A]' },
    { name: 'PRO', cycle: 'Yearly', color: 'text-[#CBB26A]' },
    { name: 'ELITE', cycle: 'Monthly', color: 'text-[#CBB26A]' },
    { name: 'ELITE', cycle: 'Yearly', color: 'text-[#CBB26A]' },
  ];

  const locations = [
    'New York, NY', 'London, UK', 'Singapore', 'Hong Kong', 'Chicago, IL',
    'San Francisco, CA', 'Toronto, CA', 'Sydney, AU', 'Dubai, UAE', 'Tokyo, JP',
    'Los Angeles, CA', 'Miami, FL', 'Boston, MA', 'Seattle, WA', 'Austin, TX'
  ];

  // Generate random timestamp (1 hour to 3 days ago)
  const generateRandomTimestamp = () => {
    const random = Math.random();

    // 70% chance: hours (1-23 hours ago)
    if (random < 0.7) {
      const hours = Math.floor(Math.random() * 23) + 1; // 1-23
      return `${hours} ${hours === 1 ? 'hour' : 'hours'} ago`;
    }
    // 30% chance: days (1-3 days ago)
    else {
      const days = Math.floor(Math.random() * 3) + 1; // 1-3
      return `${days} ${days === 1 ? 'day' : 'days'} ago`;
    }
  };

  // Show single notification after 5 seconds
  useEffect(() => {
    const timer = setTimeout(() => {
      const firstName = firstNames[Math.floor(Math.random() * firstNames.length)];
      const lastInitial = lastNames[Math.floor(Math.random() * lastNames.length)][0];
      const membership = membershipTiers[Math.floor(Math.random() * membershipTiers.length)];
      const location = locations[Math.floor(Math.random() * locations.length)];

      setNotification({
        id: 1,
        name: `${firstName} ${lastInitial}.`,
        membership: membership.name,
        cycle: membership.cycle,
        color: membership.color,
        location: location,
        timestamp: generateRandomTimestamp()
      });

      // Auto-remove after 6 seconds
      setTimeout(() => {
        setNotification(null);
      }, 6000);
    }, 5000);

    return () => clearTimeout(timer);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="fixed bottom-6 left-6 z-50 space-y-3 pointer-events-none">
      {notification && (
        <div
          key={notification.id}
          className="pointer-events-auto bg-neutral-900 border-2 border-[#CBB26A]/40 rounded-lg shadow-2xl shadow-[#CBB26A]/10 p-4 min-w-[320px] max-w-[380px] animate-slide-in-left"
        >
          <div className="flex items-start justify-between gap-3">
            <div className="flex-1">
              <div className="flex items-center gap-2 mb-1">
                <div className="w-2 h-2 bg-green-500 rounded-full animate-pulse"></div>
                <span className="text-xs text-neutral-500 font-medium">New Signup</span>
              </div>

              <div className="text-white font-bold mb-1">{notification.name}</div>

              <div className="flex items-center gap-2 text-sm mb-1">
                <span className="text-neutral-400">joined</span>
                <span className={`font-bold ${notification.color}`}>
                  {notification.membership}
                </span>
                <span className="text-neutral-500">({notification.cycle})</span>
              </div>

              <div className="flex items-center gap-2 text-xs text-neutral-600">
                <span>{notification.location}</span>
                <span>•</span>
                <span>{notification.timestamp}</span>
              </div>
            </div>

            <button
              onClick={() => setNotification(null)}
              className="text-neutral-600 hover:text-white transition p-1"
            >
              <X className="w-4 h-4" />
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default SignupNotification;
